import { DateField, ResourceComponentProps, Show, Tab, TabbedShowLayout, TextField } from 'react-admin';
import React, { FC } from 'react';

const OfferErrorShow: FC<ResourceComponentProps> = (props) => {
  return (
    <Show title="Причина отклонения" {...props}>
      <TabbedShowLayout>
        <Tab label="О причине отклонения">
          <TextField source="id" />
          <TextField label="Название" source="title" />
          <TextField label="Сообщение" source="message" />
          <DateField locales="rus" label="Создано" source="createdAt" />
          <DateField locales="rus" label="Обновлено" source="updatedAt" />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default OfferErrorShow;
